<template>
  <div class="wtb-root">

    <!-- درخت قهرمانی (فینال طلا) — رندر با vue-tournament-bracket -->
    <div class="wtb-scroll" v-if="bracket.goldTree.length" dir="ltr">
      <Bracket :flat-tree="bracket.goldTree">
        <template #player="{ player }">
          <WrestlingCell :player="player" @click="onCellClick(player)" />
        </template>
        <template #player-extension-bottom="{ match }">
          <div class="wround-chip" v-if="match.isFirstOfRound" dir="rtl">{{ match.roundFa }}</div>
        </template>
      </Bracket>
    </div>

    <!-- شاخه‌های رده‌بندی برنز (هر نیمهٔ جدول یک مسیر مستقل با رپشاژ) -->
    <div class="wtb-bronze-row" v-if="bracket.bronzeTrees.length" dir="ltr">
      <div class="wtb-bronze-block" v-for="(tree, i) in bracket.bronzeTrees" :key="'bronze-' + i">
        <div class="wtb-bronze-title" dir="rtl">
          <span class="bronze-medal">🥉</span>
          مسیر رده‌بندی {{ faNum(i + 1) }}
        </div>
        <div class="wtb-scroll wtb-scroll-bronze">
          <Bracket :flat-tree="tree">
            <template #player="{ player }">
              <WrestlingCell :player="player" @click="onCellClick(player)" />
            </template>
            <template #player-extension-bottom="{ match }">
              <div class="wround-chip" v-if="match.isFirstOfRound" dir="rtl">{{ match.roundFa }}</div>
            </template>
          </Bracket>
        </div>
      </div>
    </div>

    <!-- دیدارهای خارج از درخت: مقدماتی/رپشاژِ هنوز متصل‌نشده (قرعهٔ در جریان) -->
    <div class="wtb-leftovers" v-if="bracket.leftovers.length" dir="rtl">
      <div class="wtb-leftovers-title">⏳ دیدارهای مقدماتی و شانس مجدد (در انتظار نتیجه)</div>
      <div class="wtb-leftovers-row">
        <div
          class="wtb-leftover-card"
          v-for="m in bracket.leftovers"
          :key="m.id"
          @click="$emit('match-click', m)"
        >
          <WrestlingCell :player="toCellPlayer(m.red, m)" />
          <WrestlingCell :player="toCellPlayer(m.blue, m)" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Bracket from 'vue-tournament-bracket';
import WrestlingCell from './WrestlingCell.vue';
import { buildWrestlingBracket, toLibPlayer } from '@/utils/bracketBuilder';

export default {
  name: 'WrestlingBracket',
  components: { Bracket, WrestlingCell },
  props: {
    // خروجی /wrestling/matches/<id> (آرایهٔ مسابقات یک وزن)
    matches: { type: Array, default: () => [] },
  },
  computed: {
    bracket() {
      return buildWrestlingBracket(this.matches);
    },
  },
  methods: {
    onCellClick(player) {
      if (player && player.match) {
        this.$emit('match-click', player.match);
      }
    },
    toCellPlayer(side, match) {
      return toLibPlayer(side, match, side === match.red ? 'red' : 'blue');
    },
    faNum(v) {
      return String(v).replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    },
  },
};
</script>

<style scoped lang="scss">
.wtb-root {
  width: 100%;
}

/* اسکرول افقی نمودار (جهت LTR برای حفظ هندسهٔ خطوط اتصال کتابخانه) */
.wtb-scroll {
  overflow-x: auto;
  padding: 10px 8px 12px;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }
}

.wtb-scroll-bronze {
  padding-top: 10px;
}

/* --------- خنثی‌سازی ظاهر پیش‌فرض کتابخانه و هماهنگی با تم صفحه --------- */
::v-deep .vtb-wrapper {
  align-items: center;
  width: max-content;
  min-width: 100%;
}

::v-deep .vtb-item-players {
  background: transparent;
  color: inherit;
}

/* فاصلهٔ عمودی بازی‌ها: 10px پیش‌فرض کتابخانه → 4px (کاهش ارتفاع اسکرول نمودار) */
::v-deep .vtb-item-child {
  margin-top: 4px;
  margin-bottom: 4px;
}

::v-deep .vtb-player {
  background: transparent !important;
  padding: 2px 0;
}

::v-deep .vtb-player.winner,
::v-deep .vtb-player.defeated {
  background: transparent !important;
}

/* هایلایت یک کشتی‌گیر در سراسر درخت (قابلیت hover کتابخانه) */
::v-deep .vtb-player.highlight .wcell {
  border-color: #0d9488 !important;
  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.22);
}

/* خطوط اتصال همرنگ تم */
::v-deep .vtb-item-parent:after,
::v-deep .vtb-item-child:before,
::v-deep .vtb-item-child:after {
  background-color: #cbd5e1;
}

/* چیپ عنوان راند زیر اولین بازی هر راند */
.wround-chip {
  margin: 4px auto 0;
  width: max-content;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 100px;
  white-space: nowrap;
  line-height: 1.5;
}

/* --------- شاخه‌های برنز --------- */
.wtb-bronze-row {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.wtb-bronze-block {
  flex: 1 1 320px;
  min-width: 300px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 14px;
  padding: 12px 8px 6px;
}

.wtb-bronze-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.88rem;
  font-weight: 800;
  color: #92400e;
  padding: 0 8px;
}

.bronze-medal {
  font-size: 1rem;
}

/* --------- دیدارهای خارج از درخت --------- */
.wtb-leftovers {
  margin-top: 18px;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 14px;
  padding: 14px;
}

.wtb-leftovers-title {
  font-size: 0.85rem;
  font-weight: 800;
  color: #64748b;
  margin-bottom: 12px;
}

.wtb-leftovers-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.wtb-leftover-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: #059669;
    box-shadow: 0 4px 14px rgba(5, 150, 105, 0.12);
  }
}
</style>
